import { render, staticRenderFns } from "./dictType.vue?vue&type=template&id=f36d0526&"
import script from "./dictType.vue?vue&type=script&lang=js&"
export * from "./dictType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports